import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'display-status',
  templateUrl: './display-status.component.html',
  standalone: true,
  imports: [CommonModule, MatChipsModule]
})
export class DisplayStatusComponent {
  @Input() onlineStatus: string;
} 